// B2-INT - Ünite 2: Situational Sorular
// B2 seviyesinde mülakat senaryoları - "What would you do if..." soruları

export const B2INT_UNIT_2 = {
  'B2INT-U2-L1': {
    id: 'B2INT-U2-L1',
    title: 'What would you do if a passenger refused to fasten seatbelt?',
    type: 'interview',
    content: {
      sections: [
        {
          type: 'intro',
          title: '🎯 Situational Sorular Nedir?',
          content: 'Situational sorular = "What would you do if...?"\n\nBu sorular gelecekte nasıl davranacağını test eder:\n• Karar verme yeteneği\n• Güvenlik önceliği\n• Diplomatik iletişim\n• Prosedür bilgisi\n\n⚠️ STAR\'dan farklı: Geçmiş değil, HİPOTETİK durum!'
        },
        {
          type: 'framework',
          title: '📋 Situational Cevap Yapısı',
          content: '**1. Önceliği belirt**\n"Safety is always my first priority..."\n\n**2. Adım adım yaklaşımını anlat**\n"First, I would... Then, I would... If that doesn\'t work..."\n\n**3. Escalation (gerekirse)**\n"If the situation continues, I would involve the purser/captain..."\n\n**4. Sonucu vurgula**\n"The goal is to ensure safety while maintaining passenger comfort."'
        },
        {
          type: 'scenario',
          title: '✈️ Senaryo: Emniyet Kemeri Reddi',
          dialogues: [
            {
              speaker: 'Mülakatçı',
              text: 'What would you do if a passenger refused to fasten their seatbelt during takeoff?',
              translation: 'Bir yolcu kalkış sırasında emniyet kemerini takmayı reddederse ne yapardınız?'
            },
            {
              speaker: 'Aday (Güçlü Cevap)',
              text: 'Safety is always my top priority, so I would take this situation very seriously while remaining calm and professional.',
              translation: 'Güvenlik her zaman en önemli önceliğim, bu yüzden bu durumu sakin ve profesyonel kalarak çok ciddiye alırdım.'
            },
            {
              speaker: 'Aday (devam)',
              text: 'First, I would approach the passenger calmly and politely explain that wearing a seatbelt during takeoff and landing is a legal requirement, not just an airline rule. I would say something like: "Sir/Madam, I understand you may be uncomfortable, but this is required by aviation law for your safety."',
              translation: 'Önce yolcuya sakince yaklaşır ve emniyet kemeri takmanın sadece havayolu kuralı değil, yasal zorunluluk olduğunu kibarca açıklardım. Şöyle bir şey söylerdim: "Efendim, rahatsız olabileceğinizi anlıyorum, ama bu güvenliğiniz için havacılık yasasının gerektirdiği bir şey."'
            },
            {
              speaker: 'Aday (devam)',
              text: 'If they still refuse, I would try to understand the reason. Maybe the belt is uncomfortable, or they have a medical issue. I could offer a seatbelt extension if needed.',
              translation: 'Hala reddederlerse, nedenini anlamaya çalışırdım. Belki kemer rahatsız ediyor veya tıbbi bir sorunları var. Gerekirse kemer uzatıcısı teklif edebilirdim.'
            },
            {
              speaker: 'Aday (devam)',
              text: 'However, if they continue to refuse despite my explanations, I would inform the purser immediately. The purser may speak with them or, as a last resort, the captain may decide to delay departure or return to the gate.',
              translation: 'Ancak açıklamalarıma rağmen reddetmeye devam ederlerse, hemen kabin amirini bilgilendirirdim. Kabin amiri onlarla konuşabilir veya son çare olarak kaptan kalkışı ertelemeye veya kapıya dönmeye karar verebilir.'
            },
            {
              speaker: 'Aday (devam)',
              text: 'The key is to never compromise safety. The aircraft cannot take off with an unbelted passenger - it\'s a strict regulation.',
              translation: 'Anahtar, güvenlikten asla ödün vermemek. Uçak kemerini takmamış bir yolcuyla kalkamaz - bu kesin bir düzenleme.'
            }
          ]
        },
        {
          type: 'analysis',
          title: '📊 Cevap Analizi',
          content: '✅ **Güvenlik önceliği:** İlk cümle\n✅ **Kademeli yaklaşım:** Açıklama → Neden anlama → Çözüm önerisi → Escalation\n✅ **Yasal farkındalık:** "Aviation law" referansı\n✅ **Diplomatik:** Sakin, anlayışlı ama kararlı\n✅ **Prosedür bilgisi:** Purser → Captain zinciri'
        },
        {
          type: 'warning',
          title: '⚠️ Kötü Cevap Örnekleri',
          content: '❌ "I would force them to wear it."\n❌ "I would just ignore it."\n❌ "I would call security immediately."\n❌ "I would argue with them."\n\nBunlar neden kötü: Çok agresif, güvenliği görmezden gelme, veya aşırı tepki.'
        },
        {
          type: 'tip',
          content: '💡 ALTIN KURAL: Situational cevaplarda her zaman "escalation path" göster - tek başına karar verme, zinciri takip et!'
        }
      ],
      exercises: [
        {
          type: 'multipleChoice',
          question: 'Emniyet kemeri reddinde ilk adım ne olmalı?',
          options: [
            'Hemen güvenliği çağır',
            'Sakince yaklaş ve nedenini açıkla',
            'Yolcuyu görmezden gel',
            'Kaptana bildir'
          ],
          correctIndex: 1,
          explanation: 'İlk adım her zaman sakin, kibar açıklama. Escalation son çare.'
        }
      ]
    }
  },

  'B2INT-U2-L2': {
    id: 'B2INT-U2-L2',
    title: 'How would you handle a medical emergency?',
    type: 'interview',
    content: {
      sections: [
        {
          type: 'intro',
          title: '🎯 Tıbbi Acil Durumlar',
          content: 'Uçakta tıbbi acil durumlar oluşabilir:\n\n• Kalp krizi\n• Bayılma\n• Alerjik reaksiyon\n• Panik atak\n• Doğum (!)\n\nKabin memuru İLK MÜDAHALE yapar, doktor DEĞİL!\nAma prosedürü bilmek kritik.'
        },
        {
          type: 'scenario',
          title: '✈️ Senaryo: Yolcu Bayıldı',
          dialogues: [
            {
              speaker: 'Mülakatçı',
              text: 'How would you handle a medical emergency if a passenger collapsed during the flight?',
              translation: 'Uçuş sırasında bir yolcu bayılırsa tıbbi acil durumu nasıl ele alırdınız?'
            },
            {
              speaker: 'Aday (Güçlü Cevap)',
              text: 'In a medical emergency, I would stay calm and follow the established procedure while prioritizing the passenger\'s wellbeing.',
              translation: 'Tıbbi acil durumda, yolcunun iyiliğini ön planda tutarken sakin kalır ve belirlenen prosedürü takip ederdim.'
            },
            {
              speaker: 'Aday (devam)',
              text: 'First, I would assess the situation quickly - is the passenger conscious? Breathing? I would ask them or nearby passengers what happened.',
              translation: 'Önce durumu hızlıca değerlendirirdim - yolcu bilinci yerinde mi? Nefes alıyor mu? Onlara veya yakınlarındaki yolculara ne olduğunu sorardım.'
            },
            {
              speaker: 'Aday (devam)',
              text: 'Immediately, I would alert my colleagues and the purser. While one crew member stays with the passenger, another would make a PA announcement: "Is there a doctor or medical professional on board?"',
              translation: 'Hemen meslektaşlarımı ve kabin amirini uyarırdım. Bir ekip üyesi yolcunun yanında kalırken, başka biri PA anonsu yapardı: "Uçakta doktor veya sağlık profesyoneli var mı?"'
            },
            {
              speaker: 'Aday (devam)',
              text: 'I would bring the first aid kit and, if needed, the AED - the automatic defibrillator. If a medical professional responds to the call, I would assist them. If not, I would follow the instructions from our medical emergency protocol.',
              translation: 'İlk yardım çantasını ve gerekirse AED\'yi - otomatik defibrilatörü - getirirdim. Çağrıya bir sağlık profesyoneli yanıt verirse, onlara yardım ederdim. Vermezse, tıbbi acil durum protokolümüzdeki talimatları takip ederdim.'
            },
            {
              speaker: 'Aday (devam)',
              text: 'Throughout, I would keep the purser and captain informed. Depending on the severity, the captain might decide to divert the flight to the nearest airport.',
              translation: 'Süreç boyunca kabin amirini ve kaptanı bilgilendirirdim. Ciddiyete bağlı olarak kaptan uçuşu en yakın havalimanına yönlendirmeye karar verebilir.'
            },
            {
              speaker: 'Aday (devam)',
              text: 'Also, I would ask another crew member to keep other passengers calm and clear the area for privacy and space.',
              translation: 'Ayrıca başka bir ekip üyesinden diğer yolcuları sakin tutmasını ve mahremiyet ve alan için bölgeyi boşaltmasını isterdim.'
            }
          ]
        },
        {
          type: 'analysis',
          title: '📊 Neden Güçlü?',
          content: '✅ **Sakin kalma vurgusu**\n✅ **Sistematik yaklaşım:** Değerlendirme → Uyarı → PA → Ekipman → Protokol\n✅ **Ekip çalışması:** Görev dağılımı\n✅ **Escalation bilgisi:** Captain\'a bilgi → Uçuş yönlendirmesi\n✅ **Detaylı:** AED, first aid kit bilgisi'
        },
        {
          type: 'info',
          title: '✈️ Önemli Terimler',
          content: '• **First Aid Kit** - İlk yardım çantası\n• **AED (Automated External Defibrillator)** - Otomatik defibrilatör\n• **PA Announcement** - Kabin anonsu\n• **Divert** - Uçuşu başka havalimanına yönlendirmek\n• **Medical professional on board** - Uçaktaki sağlık profesyoneli'
        },
        {
          type: 'tip',
          content: '💡 Tıbbi acil durum cevabında: SAKİN KAL, PROSEDÜR TAKİP ET, EKİBİ BİLGİLENDİR, ESCALATİON yap. Asla "Ben doktor gibi müdahale ederim" deme!'
        }
      ],
      exercises: [
        {
          type: 'multipleChoice',
          question: 'Tıbbi acil durumda PA anonsu ne için yapılır?',
          options: [
            'Yolcuları korkutmak için',
            'Uçaktaki doktor veya sağlık profesyonelini çağırmak için',
            'Pilotu uyarmak için',
            'Bayılan kişiyi uyandırmak için'
          ],
          correctIndex: 1,
          explanation: '"Is there a doctor on board?" anonsu yapılır.'
        }
      ]
    }
  },

  'B2INT-U2-L3': {
    id: 'B2INT-U2-L3',
    title: 'What if two passengers were arguing?',
    type: 'interview',
    content: {
      sections: [
        {
          type: 'intro',
          title: '🎯 Yolcu Çatışmaları',
          content: 'Uçakta yolcular arasında çatışma çıkabilir:\n\n• Koltuk çekişmesi (reclining seat)\n• Gürültü şikayeti\n• Kol dayama kavgası\n• Bagaj alanı\n• Çocuk/bebek şikayeti\n\nKabin memuru = DİPLOMAT + HAKEM!'
        },
        {
          type: 'scenario',
          title: '✈️ Senaryo: İki Yolcu Tartışıyor',
          dialogues: [
            {
              speaker: 'Mülakatçı',
              text: 'What would you do if you saw two passengers arguing loudly on a flight?',
              translation: 'Uçuşta iki yolcunun yüksek sesle tartıştığını görseniz ne yapardınız?'
            },
            {
              speaker: 'Aday (Güçlü Cevap)',
              text: 'Maintaining a calm and safe environment is essential on a flight, so I would intervene quickly but diplomatically.',
              translation: 'Uçuşta sakin ve güvenli bir ortam korumak önemlidir, bu yüzden hızlıca ama diplomatik şekilde müdahale ederdim.'
            },
            {
              speaker: 'Aday (devam)',
              text: 'First, I would approach calmly with a friendly expression. I might say: "Good morning! Is everything alright? How can I help?" This non-accusatory approach usually de-escalates tension.',
              translation: 'Önce dostane bir ifadeyle sakince yaklaşırdım. Şöyle derdim: "Günaydın! Her şey yolunda mı? Nasıl yardımcı olabilirim?" Bu suçlayıcı olmayan yaklaşım genellikle gerilimi azaltır.'
            },
            {
              speaker: 'Aday (devam)',
              text: 'I would listen to both sides without taking sides. Each person wants to feel heard. I might say: "I understand this is frustrating for both of you. Let me see what I can do."',
              translation: 'Taraf tutmadan her iki tarafı da dinlerdim. Her kişi duyulmak ister. Şöyle derdim: "Bunun ikiniz için de sinir bozucu olduğunu anlıyorum. Ne yapabileceğime bakayım."'
            },
            {
              speaker: 'Aday (devam)',
              text: 'Then, I would try to find a practical solution. If it\'s about a reclined seat, I might offer to reseat one of them if possible. If it\'s about noise, I could offer earplugs or headphones.',
              translation: 'Sonra pratik bir çözüm bulmaya çalışırdım. Yatırılmış koltuk hakkındaysa, mümkünse birini başka koltuğa geçirmeyi teklif edebilirdim. Gürültü hakkındaysa, kulak tıkacı veya kulaklık teklif edebilirdim.'
            },
            {
              speaker: 'Aday (devam)',
              text: 'If the situation continues or escalates, I would involve the purser. In extreme cases where safety is at risk, we would follow unruly passenger procedures.',
              translation: 'Durum devam eder veya tırmanırsa, kabin amirini dahil ederdim. Güvenliğin risk altında olduğu aşırı durumlarda, huzursuz yolcu prosedürlerini takip ederdik.'
            }
          ]
        },
        {
          type: 'analysis',
          title: '📊 Cevap Analizi',
          content: '✅ **De-escalation teknikleri:** Dostane yaklaşım, suçlayıcı olmayan dil\n✅ **Tarafsızlık:** Her iki tarafı dinleme\n✅ **Empati:** "I understand this is frustrating"\n✅ **Pratik çözümler:** Koltuk değişikliği, kulak tıkacı\n✅ **Escalation yolu:** Purser → Unruly passenger procedure'
        },
        {
          type: 'info',
          title: '💬 Faydalı De-escalation İfadeleri',
          content: '• "I understand how you feel..."\n• "Let me see what I can do to help..."\n• "I apologize for the inconvenience..."\n• "Would it help if I...?"\n• "I appreciate your patience..."\n• "Let\'s find a solution together..."'
        },
        {
          type: 'warning',
          title: '⚠️ Yapılmaması Gerekenler',
          content: '❌ Bir tarafa hak vermek\n❌ "Calm down!" demek (genellikle işe yaramaz)\n❌ Sorunu görmezden gelmek\n❌ Yolcuları azarlamak\n❌ Fiziksel temas\n❌ Yüksek sesle konuşmak'
        }
      ],
      exercises: [
        {
          type: 'multipleChoice',
          question: 'İki yolcu tartışırken ilk yaklaşım nasıl olmalı?',
          options: [
            '"Please stop fighting!" diye bağırmak',
            'Dostane, suçlayıcı olmayan şekilde yaklaşmak',
            'Bir tarafa hak vermek',
            'Görmezden gelmek'
          ],
          correctIndex: 1,
          explanation: 'Sakin, dostane, tarafsız yaklaşım en etkili de-escalation yöntemidir.'
        }
      ]
    }
  },

  'B2INT-U2-L4': {
    id: 'B2INT-U2-L4',
    title: 'What if a colleague was not doing their job?',
    type: 'interview',
    content: {
      sections: [
        {
          type: 'intro',
          title: '🎯 Ekip İçi Sorunlar',
          content: 'Bu soru zor çünkü:\n\n• Ekip arkadaşını "gammazlamak" mı?\n• Görmezden gelmek mi?\n• Kendi işini yapmak mı?\n\nMülakatçı DELİKATE bir denge arıyor:\n✅ Takım odaklı\n✅ Profesyonel\n✅ Sorumluluk sahibi\n❌ Dedikodu yapmayan\n❌ Şikayetçi olmayan'
        },
        {
          type: 'scenario',
          title: '✈️ Senaryo: Çalışmayan Meslektaş',
          dialogues: [
            {
              speaker: 'Mülakatçı',
              text: 'What would you do if you noticed a colleague not doing their share of the work during a flight?',
              translation: 'Uçuş sırasında bir meslektaşınızın görevini yapmadığını fark etseniz ne yapardınız?'
            },
            {
              speaker: 'Aday (Güçlü Cevap)',
              text: 'I believe in teamwork and supporting my colleagues, so I would approach this situation with understanding rather than judgment.',
              translation: 'Takım çalışmasına ve meslektaşlarımı desteklemeye inanıyorum, bu yüzden bu duruma yargılayıcı olmak yerine anlayışla yaklaşırdım.'
            },
            {
              speaker: 'Aday (devam)',
              text: 'First, I would try to understand if there\'s a reason. Maybe they\'re feeling unwell, or dealing with a personal issue, or perhaps they didn\'t understand the task assignment.',
              translation: 'Önce bir nedeni olup olmadığını anlamaya çalışırdım. Belki kendilerini iyi hissetmiyorlar, kişisel bir sorunla uğraşıyorlar veya görev dağılımını anlamamış olabilirler.'
            },
            {
              speaker: 'Aday (devam)',
              text: 'I might approach them privately and say: "Hey, I noticed you seem a bit off today. Is everything okay? Can I help with anything?" This opens dialogue without accusing.',
              translation: 'Özel olarak yaklaşıp şöyle derdim: "Hey, bugün biraz farklı görünüyorsun. Her şey yolunda mı? Bir şeyde yardım edebilir miyim?" Bu suçlamadan diyalog açar.'
            },
            {
              speaker: 'Aday (devam)',
              text: 'During the flight, I would focus on ensuring service quality for passengers. If necessary, I might cover some of their tasks temporarily to prevent any service gaps.',
              translation: 'Uçuş sırasında yolcular için hizmet kalitesini sağlamaya odaklanırdım. Gerekirse, herhangi bir hizmet boşluğunu önlemek için geçici olarak bazı görevlerini üstlenebilirdim.'
            },
            {
              speaker: 'Aday (devam)',
              text: 'However, if this becomes a pattern that affects safety or service quality, I would speak to the purser privately after the flight. I wouldn\'t complain, but I would express concern for team performance.',
              translation: 'Ancak, bu güvenliği veya hizmet kalitesini etkileyen bir kalıp haline gelirse, uçuştan sonra kabin amiriyle özel olarak konuşurdum. Şikayet etmezdim, ama takım performansı için endişemi ifade ederdim.'
            }
          ]
        },
        {
          type: 'analysis',
          title: '📊 Neden İyi Bir Cevap?',
          content: '✅ **Empati öncelikli:** "Maybe they\'re unwell"\n✅ **Direkt değil destek:** "Can I help?"\n✅ **Yolcu odaklı:** Hizmet kalitesini koruma\n✅ **Profesyonel escalation:** Purser\'a özel olarak, şikayet değil endişe\n✅ **Takım oyuncusu:** Görevleri üstlenmeye hazır'
        },
        {
          type: 'warning',
          title: '⚠️ Kötü Yaklaşımlar',
          content: '❌ "I would report them immediately to the manager"\n❌ "I would tell other colleagues about it"\n❌ "I would confront them in front of passengers"\n❌ "I would just do their job silently without saying anything"\n❌ "I would ignore it, not my problem"'
        },
        {
          type: 'tip',
          content: '💡 DENGE KURALI: Yardımsever ol + Profesyonel kal + Gerektiğinde escalate et. Ne "gammazlamak" ne de "görmezden gelmek" - ortası!'
        }
      ],
      exercises: [
        {
          type: 'multipleChoice',
          question: 'Görevini yapmayan meslektaşa ilk yaklaşım?',
          options: [
            'Hemen yöneticiye şikayet et',
            'Özel olarak destekleyici şekilde sorunu anla',
            'Diğer ekip üyelerine anlat',
            'Sessize al ve kendin yap'
          ],
          correctIndex: 1,
          explanation: 'Önce anlayışla yaklaş ve destek teklif et. Escalation son çare.'
        }
      ]
    }
  },

  'B2INT-U2-L5': {
    id: 'B2INT-U2-L5',
    title: 'Pratik: Senaryo Çözümleme',
    type: 'simulation',
    content: {
      sections: [
        {
          type: 'intro',
          title: '🎭 Senaryo Analizi Workshopu',
          content: 'Şimdi farklı senaryoları analiz edeceğiz.\n\nHer senaryoda düşün:\n1. Öncelik ne? (Güvenlik? Hizmet? İlişki?)\n2. İlk adım ne?\n3. Escalation ne zaman?\n4. En iyi sonuç ne?'
        },
        {
          type: 'scenario',
          title: '✈️ Senaryo 1: Sarhoş Yolcu',
          dialogues: [
            {
              speaker: 'Durum',
              text: 'A passenger appears intoxicated and is being loud and disturbing other passengers. He wants to order more alcohol.',
              translation: 'Bir yolcu sarhoş görünüyor, gürültülü ve diğer yolcuları rahatsız ediyor. Daha fazla alkol sipariş etmek istiyor.'
            },
            {
              speaker: 'Anahtar Noktalar',
              text: '✅ Güvenlik öncelikli - sarhoş yolcu güvenlik riski\n✅ Alkol servisi REDDEDILMELI - yasal sorumluluk\n✅ Diplomatik ama kararlı yaklaşım\n✅ Purser bilgilendirilmeli\n✅ Gerekirse "disruptive passenger" prosedürü',
              translation: ''
            },
            {
              speaker: 'Örnek Cevap',
              text: '"I would politely but firmly decline further alcohol, saying our policy doesn\'t allow serving intoxicated passengers. I would offer water or coffee instead. If behavior continues, I would inform the purser for further action."',
              translation: '"Kibarca ama kararlı şekilde daha fazla alkol vermeyi reddeder, politikamızın sarhoş yolculara servis yapılmasına izin vermediğini söylerdim. Yerine su veya kahve teklif ederdim. Davranış devam ederse, daha fazla işlem için kabin amirini bilgilendirirdim."'
            }
          ]
        },
        {
          type: 'scenario',
          title: '✈️ Senaryo 2: Ağlayan Bebek',
          dialogues: [
            {
              speaker: 'Durum',
              text: 'A baby has been crying for 2 hours. Nearby passengers are complaining loudly about the noise.',
              translation: 'Bir bebek 2 saattir ağlıyor. Yakındaki yolcular gürültüden yüksek sesle şikayet ediyor.'
            },
            {
              speaker: 'Anahtar Noktalar',
              text: '✅ Empati HER İKİ tarafa - anne ve şikayetçiler\n✅ Anne zaten stresli, suçlama yok\n✅ Şikayetçilere kulak tıkacı, kulaklık teklifi\n✅ Anneye yardım teklifi - bebek için şişe ısıtma, vs.\n✅ Mümkünse daha sessiz bölgeye yeniden koltuk',
              translation: ''
            },
            {
              speaker: 'Örnek Yaklaşım - Anneye',
              text: '"I know traveling with a baby can be challenging. Is there anything I can do to help? Would you like me to warm a bottle, or can I bring some water?"',
              translation: '"Bebekle seyahatin zor olabileceğini biliyorum. Yardımcı olabileceğim bir şey var mı? Şişe ısıtmamı ister misiniz, yoksa biraz su getirebilir miyim?"'
            },
            {
              speaker: 'Örnek Yaklaşım - Şikayetçilere',
              text: '"I completely understand this is difficult. Unfortunately, babies sometimes cry on flights. Can I offer you some earplugs or perhaps headphones to make it more comfortable?"',
              translation: '"Bunun zor olduğunu tamamen anlıyorum. Maalesef bebekler bazen uçuşlarda ağlar. Size kulak tıkacı veya belki kulaklık teklif edebilir miyim, daha rahat olmanız için?"'
            }
          ]
        },
        {
          type: 'scenario',
          title: '✈️ Senaryo 3: VIP Talepleri',
          dialogues: [
            {
              speaker: 'Durum',
              text: 'A passenger claims to be a very important person and demands to be upgraded to business class, which is full. They threaten to complain to the CEO.',
              translation: 'Bir yolcu çok önemli biri olduğunu iddia ediyor ve dolu olan business class\'a yükseltilmek istiyor. CEO\'ya şikayet edeceğini tehdit ediyor.'
            },
            {
              speaker: 'Anahtar Noktalar',
              text: '✅ Sakin ve profesyonel kal - tehditler seni etkilemesin\n✅ Politikayı açıkla - bu yer değişikliği senin yetkinde değil\n✅ Yapabileceğini teklif et - ekstra hizmet, yastık, vb.\n✅ Purser\'a yönlendir\n✅ Asla "VIP" olduğunu sorgulama',
              translation: ''
            },
            {
              speaker: 'Örnek Cevap',
              text: '"I understand you\'d prefer more space, sir. Unfortunately, business class is fully booked today and seat changes aren\'t possible at this time. However, I\'d be happy to make your economy experience as comfortable as possible. May I bring you extra pillows or a blanket? I can also inform our purser about your request."',
              translation: '"Daha fazla alan tercih edeceğinizi anlıyorum efendim. Maalesef business class bugün tamamen dolu ve şu anda koltuk değişiklikleri mümkün değil. Ancak ekonomi deneyiminizi olabildiğince rahat yapmaktan mutluluk duyarım. Size ekstra yastık veya battaniye getirebilir miyim? Ayrıca talebinizi kabin amirimize iletebilirim."'
            }
          ]
        },
        {
          type: 'checklist',
          title: '✅ Situational Cevap Kontrol Listesi',
          content: '☐ Önceliği belirledim (güvenlik > hizmet > konfor)\n☐ Sakin ve profesyonel ton kullandım\n☐ Empati gösterdim\n☐ Adım adım yaklaşım anlattım\n☐ Escalation yolunu belirttim\n☐ Pratik çözümler sundum\n☐ Sonuç odaklı kapattım'
        }
      ],
      exercises: [
        {
          type: 'multipleChoice',
          question: 'Sarhoş yolcuya daha fazla alkol vermek için doğru yaklaşım?',
          options: [
            'İstediğini ver, müşteri her zaman haklıdır',
            'Kibarca reddet, su/kahve teklif et',
            'Görmezden gel',
            'Havalimanı güvenliğini çağır'
          ],
          correctIndex: 1,
          explanation: 'Sarhoş yolcuya alkol servisi yasaktır. Diplomatik şekilde reddet.'
        }
      ]
    }
  },

  'B2INT-U2-EXAM': {
    id: 'B2INT-U2-EXAM',
    title: 'Unit 2 Exam: Situational Questions',
    type: 'exam',
    content: {
      timeLimit: 25,
      passingScore: 70,
      questions: [
        {
          type: 'multipleChoice',
          question: 'A passenger refuses to fasten their seat belt. What is the first step?',
          options: ['Call security', 'Calmly explain the safety requirement', 'Ignore it', 'Report to captain immediately'],
          correctIndex: 1
        },
        {
          type: 'multipleChoice',
          question: 'During a medical emergency, what is a PA announcement used for?',
          options: ['To warn all passengers', 'To request medical personnel on board', 'To notify the pilot', 'To calm everyone down'],
          correctIndex: 1
        },
        {
          type: 'multipleChoice',
          question: 'When two passengers are arguing, what should you NOT do?',
          options: ['Approach calmly', 'Listen to both sides', 'Take one passenger\'s side', 'Suggest a solution'],
          correctIndex: 2
        },
        {
          type: 'multipleChoice',
          question: 'A colleague is not doing their job properly. What is the best first approach?',
          options: ['Complain to a supervisor immediately', 'Privately ask if they need support', 'Tell other colleagues about it', 'Do their work silently yourself'],
          correctIndex: 1
        },
        {
          type: 'multipleChoice',
          question: 'An intoxicated passenger requests more alcohol. What should you do?',
          options: ['Serve as much as they want', 'Politely decline and offer alternatives', 'Ignore the request', 'Scold them'],
          correctIndex: 1
        },
        {
          type: 'multipleChoice',
          question: 'Passengers complain about a crying baby. Who should you show empathy to?',
          options: ['Only the parent', 'Only the complainers', 'Both the parent and the complainers', 'No one'],
          correctIndex: 2
        },
        {
          type: 'multipleChoice',
          question: 'When should "unruly passenger" procedures be implemented?',
          options: ['During any argument', 'When there is a safety risk', 'When a passenger complains', 'Only when the captain orders'],
          correctIndex: 1
        },
        {
          type: 'multipleChoice',
          question: 'A VIP demands an upgrade that is not available. What should you do?',
          options: ['Question their VIP status', 'Offer what you CAN provide instead', 'Ignore them', 'Say they can complain to the CEO'],
          correctIndex: 1
        },
        {
          type: 'multipleChoice',
          question: 'In situational answers, what does "escalation" mean?',
          options: ['Making the problem worse', 'Referring to higher authorities when necessary', 'Arguing with the passenger', 'Ignoring the problem'],
          correctIndex: 1
        },
        {
          type: 'multipleChoice',
          question: 'In all situational scenarios, what is the MOST important priority?',
          options: ['Passenger satisfaction', 'Safety', 'Company image', 'Saving time'],
          correctIndex: 1
        }
      ]
    }
  }
};

export default B2INT_UNIT_2;
